<div class="bu-selection-wrapper">
    <!-- Step 1: Asset Selection -->
    <div *ngIf="showAssetSelection" class="bu-selection-container">
        <h2 class="page-title">Select Asset</h2>
        
        <div class="asset-container">
            <div class="bu-card" (click)="selectAsset('shale')" title="Rockies Business Unit (RBU)">
                <div class="icon-circle">
                    <span class="material-icons">public</span>
                </div>
                <h3 class="bu-code">Shale & Tight (S&T)</h3>
                <p class="bu-name">Wyoming</p>
            </div>
            
            <div class="bu-card disabled" title="Coming soon">
                <div class="icon-circle">
                    <span class="material-icons">public</span>
                </div>
                <h3 class="bu-code">Deepwater</h3>
                <p class="bu-name">Coming soon</p>
            </div>
            <div class="bu-card" (click)="selectAsset('conventional')" title="Onshore - Australia Business Unit (ABU)">
                <div class="icon-circle">
                    <span class="material-icons">public</span>
                </div>
                <h3 class="bu-code">Conventional</h3>
                <p class="bu-name">Onshore - Australia Business Unit (ABU)</p>
            </div>
            <div class="bu-card disabled" title="Coming soon">
                <div class="icon-circle">
                    <span class="material-icons">public</span>
                </div>
                <h3 class="bu-code">Exploration</h3>
                <p class="bu-name">Coming soon</p>
            </div>
        </div>
    </div>

    <!-- Step 2: BU Selection for Selected Asset -->
    <div *ngIf="showBuSelection" class="bu-selection-container">
        <h2 class="page-title">Select Well Delivery Organisation</h2>
        <p class="asset-subtitle">Asset: {{ getAssetDisplayName() }}</p>
        
        <div class="cards-container">
            <div *ngFor="let bu of getBUOptions()" class="bu-card" (click)="selectBU(bu.code)">
                <div class="icon-circle">
                    <span class="material-icons">public</span>
                </div>
                <!-- <h3 class="bu-code">{{ bu.code }}</h3> -->
                <p class="bu-name">{{ bu.name }}</p>
            </div>
        </div>

        <button class="back-button" (click)="goBack()">
            <span class="material-icons">arrow_back</span>
            Back
        </button>
    </div>
</div>
